import React, { Fragment, useEffect } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import AppHelmet from 'Components/AppHelmet'
import ToTopOnMount from 'Components/ToTopOnMount'
import { Row } from 'react-styled-flexboxgrid-tmp'
import { Link } from 'react-router'

import { Hero } from 'Layout'
import { PROPERTY_TYPE_PLURAL } from 'Config/config'
import WithSpinner from 'Components/WithSpinner'
import { urlSearchParamsToObj } from 'Utils/routerUtils'

import AreaList from './components/AreaList'
import PaginatedAddressList from './components/PaginatedAddressList'
import NewListingsList from './components/NewListingsList'

import { _SiteMap, _Main, _HeroTitle } from './styles'

import { useFetchSiteMap, useFetchRecentListings } from './apis'

const SiteMap = ({
  location,
}) => {
  const pageParams = location?.search ? urlSearchParamsToObj(location.search) : null
  const lookups = useSelector(state => state.lookups)
  // console.log(lookups)
  const { data: siteMapData, refetch, isFetching } = useFetchSiteMap({
    areaType: lookups.classType,
    id: lookups.id,
    pageParams,
  })

  const {
    data: recentListingsData,
    // refetch: refetchRecentListings,
    // isFetching: isFetchingRecentListings,
  } = useFetchRecentListings({
    areaType: lookups?.classType,
    areaId: lookups?.id,
  })


  useEffect(() => {
    if(!siteMapData) {
      refetch()
    }
    if(lookups.areaType) {
      refetch()
      // refetchRecentListings()
    }
  }, [location && location.pathname, lookups])

  const addresses = siteMapData?.addresses
  const addressPagination = addresses ? {
    perPage: addresses.per_page,
    total: addresses.total,
    currentPage: addresses.current_page,
    lastPage: addresses.last_page,
  } : null

  return (
    <_SiteMap id="heap-SiteMap" tabIndex="-1">
      <ToTopOnMount />
      <AppHelmet pagination={addressPagination} />
      <Hero image={'/static/images/hero_image_property_mobile.jpg'} height={'15vh'} bgOpacity={0.2}>
        <_HeroTitle>
          Find {PROPERTY_TYPE_PLURAL} for Sale or Rent
        </_HeroTitle>
      </Hero>
      <_Main>
        <WithSpinner
          showSpinner={!siteMapData && isFetching}
          /* spinnerContClass={css.spinnerContainer} */
        >
          {
            siteMapData ?
              <Fragment>
                {
                  siteMapData.area &&
                  <Row>
                    <h1>
                      Browse {siteMapData.area.display_name} areas or search all&nbsp;
                      <Link to={`/${siteMapData.area.url}`}>
                        {siteMapData.area.display_name} {PROPERTY_TYPE_PLURAL}
                      </Link>
                    </h1>
                  </Row>
                }
                {
                  siteMapData.sublocalities && siteMapData.sublocalities.length ?
                    <AreaList list={siteMapData.sublocalities} name="Areas" /> :
                    siteMapData.neighbourhoods && siteMapData.neighbourhoods.length ?
                      <AreaList list={siteMapData.neighbourhoods} name="Neighbourhoods" /> :
                      siteMapData.length ?
                        <AreaList list={siteMapData} name="Areas" /> :
                        null
                }
              </Fragment> : null
          }
          {
            siteMapData && siteMapData.buildings && siteMapData.buildings.length ?
              <AreaList list={siteMapData.buildings} name="Buildings" /> :
              null
          }
          {
            addresses && addresses.total > 0 ?
              <PaginatedAddressList
                addresses={addresses}
                addressPagination={addressPagination}
                location={location}
                areaName={siteMapData.area && siteMapData.area.display_name}
              />
              :
              null
          }

          {
            recentListingsData?.length ?
              <NewListingsList
                list={recentListingsData}
                sectionTitle={`New MLS Listings in ${siteMapData?.area?.display_name}`}
              />
              : ''
          }
        </WithSpinner>
      </_Main>
    </_SiteMap>
  )
}

SiteMap.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
    pathname: PropTypes.string,
  }),
}

export default SiteMap
